(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-printer-check"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ink-card-check')) {
  customElements.define('ink-card-check', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      this.dialog = dialog;
      const opener = this.querySelector('.ink-card-check__open');
      const brand = dialog.querySelector('[data-brand]');
      const input = dialog.querySelector('[data-model]');
      const list = dialog.querySelector('[data-suggestions]');
      const result = dialog.querySelector('[data-result]');
      const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
      const brands = Array.from(brand.options).map(option => option.value).filter(Boolean);
      const entries = [];
      (this.dataset.description || '').split(/[,;\n|]/).forEach(part => {
        const value = part.trim().replace(/\s+/g, ' ');
        const make = brands.find(name => value.toLowerCase().startsWith(name.toLowerCase() + ' '));
        if (!make) return;
        const model = value.slice(make.length).trim();
        if (!/\d/.test(model) || model.length > 65 || !/^[a-z0-9 .()\/-]+$/i.test(model)) return;
        if (!entries.some(entry => entry.brand === make && normalize(entry.model) === normalize(model))) entries.push({brand:make,model});
      });
      const makes = [...new Set(entries.map(entry => entry.brand))];
      if (makes.length === 1) { brand.value = makes[0]; input.disabled = false; }
      let confettiTimer;
      let lastCelebration = 0;
      const clearConfetti = () => {
        clearTimeout(confettiTimer);
        result.querySelector('.ink-compat__confetti')?.remove();
      };
      this.clearConfetti = clearConfetti;
      const celebrate = () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || Date.now() - lastCelebration < 2000) return;
        lastCelebration = Date.now();
        clearConfetti();
        const layer = document.createElement('span');
        layer.className = 'ink-compat__confetti';
        layer.setAttribute('aria-hidden', 'true');
        result.append(layer);
        for (let i = 0; i < 18; i++) {
          const piece = document.createElement('span');
          piece.className = 'ink-compat__confetti-piece';
          piece.style.backgroundColor = i % 2 ? '#ffb300' : '#1e2d7d';
          layer.append(piece);
          const spread = (i / 17 - 0.5) * Math.min(result.clientWidth - 16, 280);
          const lift = 28 + Math.random() * 42;
          const turn = (i % 2 ? 1 : -1) * (100 + Math.random() * 160);
          piece.animate([
            { transform: 'translate(0, 0) rotate(0deg)', opacity: 0 },
            { transform: 'translate(' + spread * 0.65 + 'px, -' + lift + 'px) rotate(' + turn * 0.5 + 'deg)', opacity: 0.85, offset: 0.4 },
            { transform: 'translate(' + spread + 'px, 35px) rotate(' + turn + 'deg)', opacity: 0 }
          ], { duration: 1800, delay: 0, easing: 'cubic-bezier(.2,.65,.35,1)', fill: 'both' });
        }
        confettiTimer = setTimeout(clearConfetti, 1900);
      };
      const check = () => {
        clearConfetti();
        const match = entries.some(entry => entry.brand === brand.value && normalize(entry.model) === normalize(input.value));
        result.textContent = match ? result.dataset.yes : result.dataset.unknown;
        result.dataset.match = String(match);
        list.hidden = true;
        if (match) celebrate();
      };
      const refresh = () => {
        clearConfetti();
        result.textContent = '';
        delete result.dataset.match;
        const query = normalize(input.value);
        const matches = entries.filter(entry => entry.brand === brand.value && normalize(entry.model).includes(query));
        list.replaceChildren(...matches.map(entry => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = entry.model;
          button.addEventListener('click', () => { input.value = entry.model; input.focus(); check(); });
          return button;
        }));
        list.hidden = !matches.length;
      };
      opener.addEventListener('click', () => { document.body.append(dialog); dialog.showModal(); brand.focus(); });
      dialog.querySelector('.ink-compat__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { clearConfetti(); if(this.isConnected) { this.append(dialog); opener.focus(); } });
      dialog.addEventListener('click', event => {
        if(event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      brand.addEventListener('change', () => { input.value = ''; input.disabled = !brand.value; refresh(); if(brand.value) input.focus(); });
      input.addEventListener('input', refresh);
      input.addEventListener('focus', refresh);
      input.addEventListener('keydown', event => {
        if(event.key === 'ArrowDown' && !list.hidden && list.firstElementChild) { event.preventDefault(); list.firstElementChild.focus(); }
      });
      list.addEventListener('keydown', event => {
        if(event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const next = event.key === 'ArrowDown' ? event.target.nextElementSibling : event.target.previousElementSibling;
          if(next) next.focus(); else input.focus();
        }
      });
      dialog.querySelector('form').addEventListener('submit', event => { event.preventDefault(); if(brand.value && input.value.trim()) check(); });
    }
    disconnectedCallback() { this.clearConfetti?.(); if(this.dialog) this.dialog.remove(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-colour-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
 const link = event.target.closest('a[data-ink-colour]');
 if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
 const target = new URL(link.href);
 const current = new URL(location.href);
 current.searchParams.forEach((value, key) => {
  if (key !== 'page' && key !== 'section_id' && key !== 'sections' && key !== 'sort_by') target.searchParams.append(key,value);
 });
 if (current.searchParams.has('sort_by')) target.searchParams.set('sort_by',current.searchParams.get('sort_by'));
 event.preventDefault();
 location.assign(target.href);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-contact-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ink-footer-contact')) {
  customElements.define('ink-footer-contact', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      const status = this.querySelector('[data-service-status]');
      const text = this.querySelector('[data-status-text]');
      const hint = this.querySelector('[data-closed-hint]');
      const clock = new Intl.DateTimeFormat('en-GB', { timeZone:'Europe/Amsterdam', weekday:'short', hour:'2-digit', hourCycle:'h23' });
      const update = () => {
        const parts = Object.fromEntries(clock.formatToParts(new Date()).map(part => [part.type,part.value]));
        const open = ['Mon','Tue','Wed','Thu','Fri'].includes(parts.weekday) && Number(parts.hour) >= 9 && Number(parts.hour) < 17;
        const next = open ? status.dataset.open : status.dataset.closed;
        if(text.textContent !== next) text.textContent = next;
        status.dataset.isOpen = String(open);
        status.hidden = false;
        hint.hidden = open;
      };
      update();
      this.timer = setInterval(update, 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.timer = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-livechat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ink-header-chat')) {
  customElements.define('ink-header-chat', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button');
      button.addEventListener('click', () => {
        if (this.pending) return;
        this.pending = true;
        button.setAttribute('aria-busy', 'true');
        const deadline = Date.now() + 10000;
        const open = () => {
          if (!this.isConnected) return;
          const chat = document.querySelector('shopify-chat');
          if (chat && typeof chat.show === 'function') {
            chat.show();
            this.pending = false;
            button.removeAttribute('aria-busy');
          } else if (Date.now() < deadline) {
            this.timer = setTimeout(open, 150);
          } else {
            if (chat) chat.setAttribute('open', '');
            this.pending = false;
            button.removeAttribute('aria-busy');
          }
        };
        open();
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.pending = false;
      this.querySelector('button')?.removeAttribute('aria-busy');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-toner-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ink-toner-finder')) {
  customElements.define('ink-toner-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const brand = this.querySelector('[data-brand]');
      const model = this.querySelector('[data-model]');
      const models = JSON.parse(this.querySelector('[data-printer-models]').textContent);
      const list = this.querySelector('[data-model-list]');
      const normalize = value => value.toLowerCase().replace(/[\s-]/g, '');
      const refreshModels = () => {
        const query = normalize(model.value);
        const matches = (models[brand.value] || []).filter(value => normalize(value).includes(query));
        list.replaceChildren(...matches.map(value => {
          const option = document.createElement('button');
          option.type = 'button';
          option.textContent = value;
          option.addEventListener('mousedown', event => event.preventDefault());
          option.addEventListener('click', () => { model.value = value; model.focus(); list.hidden = true; });
          return option;
        }));
        list.hidden = matches.length === 0;
      };
      model.addEventListener('focus', refreshModels);
      model.addEventListener('input', refreshModels);
      model.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); list.hidden = true; }
        if (event.key === 'ArrowDown' && !list.hidden && list.firstElementChild) { event.preventDefault(); list.firstElementChild.focus(); }
      });
      list.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); model.focus(); list.hidden = true; }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const next = event.key === 'ArrowDown' ? event.target.nextElementSibling : event.target.previousElementSibling;
          if (next) next.focus(); else model.focus();
        }
      });
      this.addEventListener('focusout', () => { setTimeout(() => { if (!this.contains(document.activeElement)) list.hidden = true; }, 0); });
      brand.addEventListener('change', () => { model.value = ''; model.focus(); refreshModels(); });
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-help-open]');
      this.helpDialog = dialog;
      opener.addEventListener('click', () => { document.body.append(dialog); dialog.showModal(); });
      dialog.querySelector('[data-help-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target !== dialog) return; const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); });
      dialog.addEventListener('close', () => { if (this.isConnected) { this.append(dialog); const menu = this.closest('[data-type="menu"]'); const trigger = menu && document.querySelector('[aria-controls="' + menu.id + '"]'); if (menu && menu.getAttribute('aria-hidden') === 'true' && trigger) trigger.focus(); else opener.focus(); } });
      form.addEventListener('submit', event => {
        const clean = model.value.trim().replace(/["\\:()*]/g, ' ').replace(/\s+/g, ' ').trim();
        if (!brand.value || !clean) { event.preventDefault(); model.focus(); return; }
        this.querySelector('[data-query]').value = brand.value + ' "' + clean + '" toner';
      });
    }
    disconnectedCallback() { if (this.helpDialog) this.helpDialog.remove(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-scroll-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ink-scroll-search')) {
  customElements.define('ink-scroll-search', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.frame = 0;
      this.pinnedAt = null;
      this.header = this.closest('.header');
      this.wrapper = this.header?.querySelector('.header__search-bar-wrapper');
      this.input = this.wrapper?.querySelector('input[name="q"]');
      this.button = this.querySelector('button');
      if (!this.header || !this.wrapper || !this.input || !this.button) return;
      this.mobile = matchMedia('(max-width:640px)');
      this.collapsed = this.header.classList.contains('ink-search-collapsed');
      const options = { signal:this.controller.signal };
      this.setCollapsed = (next) => {
        if (next === this.collapsed) return;
        this.collapsed = next;
        this.header.classList.toggle('ink-search-collapsed', next);
        this.button.setAttribute('aria-expanded', String(!next));
      };
      this.update = () => {
        this.frame = 0;
        if (!this.isConnected) return;
        if (!this.mobile.matches) { this.setCollapsed(false); this.pinnedAt = null; return; }
        const y = Math.max(0, window.scrollY);
        const active = this.wrapper.contains(document.activeElement) || this.wrapper.classList.contains('is-fixed');
        if (active) { this.setCollapsed(false); return; }
        if (y < 24) { this.pinnedAt = null; this.setCollapsed(false); return; }
        if (this.pinnedAt !== null) {
          if (y <= this.pinnedAt + 160) return;
          this.pinnedAt = null;
        }
        if (!this.collapsed && y > 220) this.setCollapsed(true);
      };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };
      this.button.addEventListener('click', () => {
        this.pinnedAt = Math.max(0, window.scrollY);
        this.wrapper.classList.add('is-visible');
        this.setCollapsed(false);
        this.input.focus({preventScroll:true});
      }, options);
      window.addEventListener('scroll', this.schedule, { ...options, passive:true });
      window.addEventListener('resize', this.schedule, options);
      this.wrapper.addEventListener('focusout', this.schedule, options);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.wrapper, {attributes:true,attributeFilter:['class']});
      this.schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vat-display"] && !Shopify.designMode) return;
  try {
    (() => {
 if (window.inkVatRunning) return;
 window.inkVatRunning = true;
 const config = window.inkVatConfig;
 const format = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency',currency:config.currency || 'EUR'});
 const mode = () => document.documentElement.dataset.vatMode || 'excl';
 const makePrice = (amount, factor) => {
   const gross = config.included ? amount : amount * factor;
   const net = config.included ? amount / factor : amount;
   const wrapper = document.createElement('span');
   wrapper.className = 'ink-vat-price';
   for (const [key,value,label] of [['ex',net,config.excl],['in',gross,config.incl]]) {
     const line = document.createElement('span');
     line.className = 'ink-vat-price__' + key;
     line.append(document.createTextNode(format.format(value / 100) + ' '));
     const small = document.createElement('small'); small.textContent = label; line.append(small); wrapper.append(line);
   }
   return wrapper;
 };
 const parse = text => {
   const match = text.match(/(?:€|EUR)\s*([\d.,]+)|([\d.,]+)\s*(?:€|EUR)/);
   if (!match) return null;
   let number = match[1] || match[2];
   if (number.includes(',')) number = number.replace(/\./g,'').replace(',','.');
   return Math.round(Number(number) * 100);
 };
 let frame = 0;
 const sync = () => {
   frame = 0;
   observer.disconnect();
   document.querySelectorAll('[data-vat-choice]').forEach(el => { if(el.value !== mode()) el.value = mode(); });
   document.querySelectorAll('option[data-vat-option]').forEach(option => {
     const amount = Number(option.dataset.vatOption), factor = Number(option.dataset.vatFactor);
     const value = mode() === 'incl' ? (config.included ? amount : amount * factor) : (config.included ? amount / factor : amount);
     const label = option.dataset.vatTitle + ' - ' + format.format(value / 100) + ' ' + (mode() === 'incl' ? config.incl : config.excl);
     if(option.textContent !== label) option.textContent = label;
   });
   document.querySelectorAll('[data-vat-context]').forEach(context => {
     const factor = Number(context.dataset.vatContext) || 1.21;
     context.querySelectorAll('.price,.unit-price-measurement__price').forEach(el => {
       if(el.querySelector('.ink-vat-price')) return;
       const amount = parse(el.textContent);
       if(amount === null) return;
       const hidden = Array.from(el.querySelectorAll('.visually-hidden'));
       el.replaceChildren(...hidden,makePrice(amount,factor));
     });
   });
   observer.observe(document.body,{childList:true,subtree:true,characterData:true});
 };
 const schedule = () => { if(!frame) frame = requestAnimationFrame(sync); };
 const observer = new MutationObserver(schedule);
 document.addEventListener('change', event => {
   if (!event.target.matches('[data-vat-choice]')) return;
   document.documentElement.dataset.vatMode = event.target.value === 'incl' ? 'incl' : 'excl';
   try { localStorage.setItem('ink-vat-mode',mode()); } catch(e) {}
   schedule();
 });
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',sync,{once:true}); else sync();
})();
  } catch(e) { console.error(e); }
})();

})();
